/* Check Images url and add cdn if not present */
export const appendCdnToImagePath = (image: string): string => {
  /* isHttp regex is only for hardcoded images only */
  const isHttp = image.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)/);
  const isCdn = image.match(/^(\/cdn\/)/);
  if (isHttp || isCdn) {
    return image;
  } else {
    return `/cdn${image}`;
  }
};
